
import { Vue, Component } from "vue-property-decorator";

@Component
export default class TopBanner extends Vue {
  onClicked(): void {
    window.open("https://calendly.com/t-stadler-1/meeting-auf-e-world");
  }
}
